import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import {
  type ClickstreamEventParams,
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_OBJECT,
  TRIGGER_TYPE,
} from './globals';

const EVENT_TEMPLATE_ID = '628';
const TRIGGER_SOURCE = 'request_renter_profile_button';

// https://dataportal.zillowgroup.net/event-registry/3660
export const emitDisplayRequestRenterProfileButtonEvent = ({
  user,
  listing,
  triggerLocation,
  lead,
}: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '3660',
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

// https://dataportal.zillowgroup.net/event-registry/3661
export const REQUEST_RENTER_PROFILE_CLICK_EVENT_TYPE_ID = '3661';
export const emitRequestRenterProfileClickEvent = ({ user, listing, triggerLocation, lead }: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: REQUEST_RENTER_PROFILE_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
